import React, {ChangeEvent, useEffect, useState} from 'react';
import b_ from 'b_';

import {SurveyTextDirection} from 'client/common/types';
import {SelectWithForwardView as Select} from 'client/common/components/lego';
import BlockInput from 'client/common/components/block-input';

import {useCanEditSurveySettings} from 'client/common/hooks/edit-mode';
import {useSurveySlug} from 'client/common/contexts/slug';
import {useSurvey, useUpdateSurveySettings} from 'client/common/hooks/survey';

import I18N from 'assets/i18n/brandlift-project';

const i18n = I18N.common.surveySettings.editSettingsModal;

const DIR_OPTIONS = Object.values(SurveyTextDirection).map(value => ({
    value,
    content: i18n.textDirection[value]
}));

const b = b_.with('edit-settings-modal');

export default function SurveyTextDirectionSelect() {
    const canEdit = useCanEditSurveySettings();
    const slug = useSurveySlug();
    const survey = useSurvey(slug);
    const onUpdate = useUpdateSurveySettings(slug);

    const [dir, setDir] = useState(survey.data?.settings.dir);

    useEffect(() => {
        setDir(survey.data?.settings.dir);
    }, [survey.data?.settings.dir]);

    const handleDirChange = async (event: ChangeEvent<HTMLSelectElement>) => {
        const newDir = event.target.value as SurveyTextDirection;

        setDir(newDir);
        await onUpdate({
            dir: newDir
        });
    };

    return (
        <BlockInput className={b('input-wrapper')} title={i18n.textDirection.label}>
            <Select
                className={b('select-control')}
                disabled={!canEdit}
                onChange={handleDirChange}
                options={DIR_OPTIONS}
                size='m'
                value={dir ?? SurveyTextDirection.LTR}
                view='dl-clear'
            />
        </BlockInput>
    );
}
